import React from 'react'

import { Form, Col } from '_zari/core'

const ProcesoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='PROCESO' htmlFor='input-proceso' md={2} />
      <Col md={10}>
        <Form.InputText
          value={value}
          onChange={onChange}
          id='input-proceso'
          placeholder='Ingresar proceso ...'
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ProcesoFormGroup)
